<template>
  <div class="alben-screen">
    <div class="filter-toolbar mb-4">
      <v-btn
        size="small"
        variant="tonal"
        prepend-icon="mdi-filter-variant"
        @click="personFilterDialog = true"
      >
        Filter Personen
      </v-btn>
      <v-btn
        size="small"
        variant="tonal"
        prepend-icon="mdi-image-multiple"
        @click="mediaFilterDialog = true"
      >
        Filter Medien
      </v-btn>
      <span class="filter-summary">
        {{ personenFilterSummary }}
      </span>
      <span class="filter-summary">
        {{ mediaFilterSummary }}
      </span>
    </div>

    <v-dialog
      v-model="personFilterDialog"
      max-width="720"
      scrollable
    >
      <v-card>
        <v-card-title class="d-flex align-center">
          Filter Personen
          <v-spacer />
          <v-btn
            icon="mdi-close"
            variant="text"
            density="comfortable"
            @click="personFilterDialog = false"
          />
        </v-card-title>

        <v-card-text>
          <v-checkbox
            v-model="nurBilderMitPersonenTags"
            label="Nur Bilder mit Personen-Tags anzeigen"
            hide-details
            density="compact"
          />

          <v-row v-if="verfuegbarePersonenTags.length" class="mt-2">
            <v-col
              v-for="tag in verfuegbarePersonenTags"
              :key="tag"
              cols="12"
              sm="6"
              md="4"
            >
              <v-checkbox
                v-model="ausgewaehltePersonenTags"
                :label="tag"
                :value="tag"
                hide-details
                density="compact"
              />
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions class="filter-actions">
          <v-btn size="small" @click="alleTagsAuswaehlen">
            Alle auswaehlen
          </v-btn>

          <v-btn size="small" variant="outlined" @click="alleTagsAbwaehlen">
            Alle abwaehlen
          </v-btn>

          <v-spacer />

          <v-btn
            size="small"
            color="primary"
            variant="flat"
            @click="personFilterDialog = false"
          >
            Anwenden
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div v-if="isLoading" class="image-grid">
      <v-skeleton-loader
        v-for="n in page_numberofitems"
        :key="`skeleton-${n}`"
        type="image, article"
        class="image-skeleton"
      />
    </div>

    <div v-else-if="albumMediaItems.length" class="image-grid">
      <div
        v-for="media in albumMediaItems"
        :key="media.key"
        class="image-card"
        @click="openAlbumMedia(media)"
      >
        <div class="image-thumb-wrapper">
          <img
            v-if="media.type === 'image' || (media.type === 'video' && !media.item.thumbLoadFailed)"
            :src="media.type === 'video' ? getVideoThumbBrowserUrl(media.item, { regenerate: true }) : encodeUriSafe(media.item.Icon_URL)"
            :srcset="media.type === 'image' ? (media.item.Icon_srcset || '') : ''"
            :sizes="media.type === 'image' ? (media.item.Icon_sizes || defaultImageSizes) : defaultImageSizes"
            :alt="media.title"
            class="image-thumb"
            loading="lazy"
            decoding="async"
            @error="media.type === 'video' && handleVideoThumbnailError(media.item)"
          >

          <div
            v-else
            class="video-thumb-placeholder"
          >
            <v-icon icon="mdi-play-circle" size="44" />
          </div>

          <span
            v-if="media.type === 'video'"
            class="video-play-overlay"
          >
            <v-icon icon="mdi-play" size="28" />
          </span>
        </div>

        <div class="image-meta">
          <div class="meta-title">
            {{ media.title }}
          </div>

          <div
            class="meta-line"
          >
            {{ media.idText }}
          </div>

          <div
            v-if="media.type === 'video'"
            class="meta-line"
          >
            Laenge: {{ media.durationText }}
          </div>

          <div
            v-if="media.type === 'video'"
            class="meta-line"
          >
            Groesse: {{ media.sizeText }}
          </div>

          <div
            v-if="media.type === 'image' && media.item.personTags && media.item.personTags.length"
            class="meta-line tag-line"
          >
            {{ media.item.personTags.join(', ') }}
          </div>

          <div
            class="meta-line"
          >
            Face erkannt am:
            {{ media.faceText }}
          </div>

          <div
            class="meta-line"
          >
            {{ media.dateText }}
          </div>

          <div
            v-if="media.hasCoordinates"
            class="meta-line"
          >
            GPS: {{ formatCoordinate(media.latitude) }},
            {{ formatCoordinate(media.longitude) }}
          </div>

        </div>
      </div>
    </div>

    <v-alert
      v-else
      type="info"
      variant="tonal"
      class="my-4"
    >
      Keine Medien fuer den aktuellen Filter gefunden.
    </v-alert>

    <v-alert
      v-if="videoError"
      type="error"
      variant="tonal"
      density="compact"
      class="mt-3"
    >
      {{ videoError }}
    </v-alert>

    <v-pagination
      v-model="page"
      :length="page_numberofpages"
      @update:model-value="springeZuSeite"
      class="my-4"
    />

    <v-dialog
      v-model="dialog"
      fullscreen
      transition="dialog-bottom-transition"
      :overlay="false"
    >
      <v-card
        v-if="aktuellesBild"
        :loading="uploadstarted"
      >
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="dialog = false">
            <v-icon icon="mdi-close" />
          </v-btn>
          <v-toolbar-title>Vollbild</v-toolbar-title>
        </v-toolbar>

        <v-text-field
          label="assembly_Benennung"
          v-model="aktuellesBild.assembly_Benennung"
        />

        <v-text-field
          label="Bilder_Benennung"
          v-model="aktuellesBild.Bilder_Benennung"
        />

        <v-text-field
          label="bilder_UploadDate"
          v-model="aktuellesBild.bilder_UploadDate"
        />

        <v-row class="geo-fields">
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="aktuellesBild.bilder_geo_lati_Y"
              label="Latitude / Breite"
              type="number"
              step="any"
            />
          </v-col>

          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="aktuellesBild.bilder_geo_longi_X"
              label="Longitude / Laenge"
              type="number"
              step="any"
            />
          </v-col>
        </v-row>

        <v-card-actions class="map-actionbar">
          <v-tooltip text="Bilddaten speichern" location="bottom">
            <template #activator="{ props }">
              <v-btn
                v-bind="props"
                icon="mdi-content-save"
                density="comfortable"
                @click="saveMasterdata('schalter')"
              />
            </template>
          </v-tooltip>

          <v-tooltip text="Weiteres Bild zu diesem Assembly hinzufuegen" location="bottom">
            <template #activator="{ props }">
              <v-btn
                v-bind="props"
                icon="mdi-image-plus"
                density="comfortable"
                @click="openAdditionalUpload"
              />
            </template>
          </v-tooltip>

          <v-tooltip text="Video zu diesem Assembly hinzufuegen" location="bottom">
            <template #activator="{ props }">
              <v-btn
                v-bind="props"
                icon="mdi-video-plus"
                density="comfortable"
                @click="openVideoUpload"
              />
            </template>
          </v-tooltip>

          <v-tooltip text="Bild um 90 Grad drehen" location="bottom">
            <template #activator="{ props }">
              <v-btn
                v-bind="props"
                icon="mdi-crop-rotate"
                density="comfortable"
                @click="rotate90Bild('schalter')"
              />
            </template>
          </v-tooltip>

          <v-tooltip text="Bild loeschen" location="bottom">
            <template #activator="{ props }">
              <v-btn
                v-bind="props"
                icon="mdi-delete"
                density="comfortable"
                @click="openDeleteDialog"
              />
            </template>
          </v-tooltip>
        </v-card-actions>

        <div class="map-section">
          <div class="map-title">
            Kartenansicht
          </div>

          <iframe
            v-if="hasCurrentCoordinates"
            :src="currentMapUrl"
            class="map-frame"
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"
          />

          <v-alert
            v-else
            type="info"
            variant="tonal"
            density="compact"
          >
            Keine gueltigen Geo-Koordinaten fuer dieses Bild vorhanden.
          </v-alert>

          <v-btn
            v-if="hasCurrentCoordinates"
            :href="currentOsmUrl"
            target="_blank"
            rel="noopener"
            variant="outlined"
            size="small"
            class="mt-2"
          >
            In OpenStreetMap oeffnen
          </v-btn>
        </div>

        <v-alert
          v-if="uploadsuccess"
          type="success"
          variant="tonal"
          density="compact"
          class="mx-4 mt-3"
        >
          Bild wurde zum Assembly hinzugefuegt.
          <span v-if="uploadGeoInfo">
            {{ uploadGeoInfo }}
          </span>
        </v-alert>

        <v-alert
          v-if="uploaderror"
          type="error"
          variant="tonal"
          density="compact"
          class="mx-4 mt-3"
        >
          {{ uploadErrorMessage || 'Bild konnte nicht hochgeladen werden.' }}
        </v-alert>

        <v-img
          v-if="dialog && aktuellesBild && aktuellesBild.Bild_URL"
          :src="aktuellesBild.Bild_URL"
          cover
        />
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="mediaFilterDialog"
      max-width="420"
    >
      <v-card>
        <v-card-title class="d-flex align-center">
          Filter Medien
          <v-spacer />
          <v-btn
            icon="mdi-close"
            variant="text"
            density="comfortable"
            @click="mediaFilterDialog = false"
          />
        </v-card-title>

        <v-card-text>
          <v-btn-toggle
            v-model="mediaTypeFilter"
            mandatory
            density="compact"
            class="media-filter-toggle"
          >
            <v-btn value="all" size="small">
              Alle
            </v-btn>
            <v-btn value="images" size="small">
              Bilder
            </v-btn>
            <v-btn value="videos" size="small">
              Videos
            </v-btn>
          </v-btn-toggle>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn
            size="small"
            color="primary"
            variant="flat"
            @click="mediaFilterDialog = false"
          >
            Anwenden
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="showVideoUpload"
      max-width="640"
    >
      <v-card>
        <v-card-title>Video zu diesem Assembly hinzufuegen</v-card-title>

        <v-card-text>
          <div class="upload-target">
            Assembly:
            <strong>{{ aktuellesBild?.assembly_Benennung || '-' }}</strong>
          </div>

          <v-file-input
            v-model="videoFile"
            label="Videodatei auswaehlen"
            accept="video/mp4,video/quicktime,video/webm"
            show-size
            density="compact"
            prepend-icon="mdi-video-plus"
          />

          <v-text-field
            v-model="videoName"
            label="Video_Benennung"
            density="compact"
            hide-details
          />

          <v-alert
            v-if="videoError"
            type="error"
            variant="tonal"
            density="compact"
            class="mt-4"
          >
            {{ videoError }}
          </v-alert>
        </v-card-text>

        <v-card-actions>
          <v-spacer />

          <v-btn
            variant="text"
            :disabled="videoUploadStarted"
            @click="resetVideoUpload"
          >
            Abbrechen
          </v-btn>

          <v-btn
            color="primary"
            :disabled="!selectedVideoFile || !AssemblyID || videoUploadStarted"
            :loading="videoUploadStarted"
            @click="uploadVideo"
          >
            Hochladen
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="videoDialog"
      max-width="960"
    >
      <v-card>
        <v-card-title class="d-flex align-center">
          {{ selectedVideo?.video_benennung || selectedVideo?.title || 'Video' }}
          <v-spacer />
          <v-btn
            icon="mdi-close"
            variant="text"
            @click="closeVideo"
          />
        </v-card-title>

        <v-card-text>
          <v-text-field
            :model-value="selectedVideoAssemblyName"
            label="assembly_Benennung"
            readonly
          />

          <v-text-field
            :model-value="selectedVideoName"
            label="Bilder_Benennung"
            readonly
          />

          <v-text-field
            :model-value="selectedVideoUploadDate"
            label="bilder_UploadDate"
            readonly
          />

          <v-row class="geo-fields">
            <v-col
              cols="12"
              md="6"
            >
              <v-text-field
                :model-value="selectedVideoLatitude"
                label="Latitude / Breite"
                readonly
              />
            </v-col>

            <v-col
              cols="12"
              md="6"
            >
              <v-text-field
                :model-value="selectedVideoLongitude"
                label="Longitude / Laenge"
                readonly
              />
            </v-col>
          </v-row>

          <v-card-actions class="map-actionbar video-actionbar">
            <v-tooltip text="Weiteres Bild zu diesem Assembly hinzufuegen" location="bottom">
              <template #activator="{ props }">
                <v-btn
                  v-bind="props"
                  icon="mdi-image-plus"
                  density="comfortable"
                  @click="openAdditionalUpload"
                />
              </template>
            </v-tooltip>

            <v-tooltip text="Video zu diesem Assembly hinzufuegen" location="bottom">
              <template #activator="{ props }">
                <v-btn
                  v-bind="props"
                  icon="mdi-video-plus"
                  density="comfortable"
                  @click="openVideoUpload"
                />
              </template>
            </v-tooltip>

            <v-tooltip text="Thumbnail neu erzeugen" location="bottom">
              <template #activator="{ props }">
                <v-btn
                  v-bind="props"
                  icon="mdi-image-sync"
                  density="comfortable"
                  :loading="videoThumbRefreshStarted === getVideoId(selectedVideo)"
                  :disabled="!getVideoId(selectedVideo) || Boolean(videoThumbRefreshStarted)"
                  @click="refreshVideoThumbnail(selectedVideo)"
                />
              </template>
            </v-tooltip>

            <v-tooltip text="Video loeschen" location="bottom">
              <template #activator="{ props }">
                <v-btn
                  v-bind="props"
                  icon="mdi-delete"
                  density="comfortable"
                  color="error"
                  :loading="videoDeleteStarted === getVideoId(selectedVideo)"
                  :disabled="!getVideoId(selectedVideo) || Boolean(videoDeleteStarted)"
                  @click="deleteVideo(selectedVideo)"
                />
              </template>
            </v-tooltip>
          </v-card-actions>

          <video
            v-if="selectedVideoStreamUrl"
            :src="selectedVideoStreamUrl"
            class="video-player"
            controls
            autoplay
            preload="metadata"
            @error="handleVideoStreamError"
          />

          <v-alert
            v-if="videoStreamError"
            type="error"
            variant="tonal"
            density="compact"
            class="mt-3"
          >
            {{ videoStreamError }}
          </v-alert>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="showAdditionalUpload"
      max-width="640"
    >
      <v-card>
        <v-card-title>Weiteres Bild zu diesem Assembly hinzufuegen</v-card-title>

        <v-card-text>
          <div class="upload-target">
            Assembly:
            <strong>{{ aktuellesBild?.assembly_Benennung || '-' }}</strong>
          </div>

          <v-file-input
            v-model="additionalImageFile"
            label="Bilddatei auswaehlen"
            show-size
            density="compact"
            prepend-icon="mdi-image-plus"
            hint="Android Chrome: ueber Dateien/Original-JPG waehlen, nicht ueber Schnellvorschau. So bleiben EXIF-GPS-Daten eher erhalten."
            persistent-hint
          />

          <v-alert
            v-if="uploadGeoInfo"
            :type="uploadGeoInfoType"
            variant="tonal"
            density="compact"
            class="mb-4"
          >
            {{ uploadGeoInfo }}
          </v-alert>

          <div
            v-if="manualUploadCoordinates"
            class="manual-upload-coordinates"
          >
            Aktuelle Position:
            {{ formatCoordinate(manualUploadCoordinates.latitude) }},
            {{ formatCoordinate(manualUploadCoordinates.longitude) }}
          </div>

          <v-text-field
            v-model="additionalImageName"
            label="Bilder_Benennung"
            density="compact"
            hide-details
          />
        </v-card-text>

        <v-card-actions>
          <v-spacer />

          <v-btn
            variant="text"
            :disabled="uploadstarted"
            @click="resetAdditionalUpload"
          >
            Abbrechen
          </v-btn>

          <v-btn
            variant="outlined"
            :loading="manualGeoLoading"
            :disabled="uploadstarted"
            @click="useCurrentPositionForUpload"
          >
            Aktuelle Position verwenden
          </v-btn>

          <v-btn
            color="primary"
            :disabled="!selectedAdditionalImageFile || !AssemblyID || uploadstarted"
            :loading="uploadstarted"
            @click="uploadAdditionalImage"
          >
            Hochladen
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="deleteDialog"
      max-width="520"
    >
      <v-card>
        <v-card-title>Bild loeschen?</v-card-title>

        <v-card-text>
          Das Bild
          <strong>{{ aktuellesBild?.idBilder || '-' }}</strong>
          wird dauerhaft geloescht.
        </v-card-text>

        <v-card-actions>
          <v-spacer />

          <v-btn
            variant="text"
            :disabled="deleteStarted"
            @click="deleteDialog = false"
          >
            Abbrechen
          </v-btn>

          <v-btn
            color="error"
            :loading="deleteStarted"
            :disabled="!aktuellesBild?.idBilder"
            @click="confirmDeleteBild"
          >
            Loeschen
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import axios from '@/api/client'
import imageUploadGeo from '@/mixins/imageUploadGeo'
import { formatImageUploadError } from '@/utils/imageUploadError'
import { getApiBaseUrl } from '@/config/appConfig'

export default {
  mixins: [imageUploadGeo],
  name: 'AlbenScreen',

  data() {
    return {
      dialog: false,
      deleteDialog: false,
      showSuccessAlert: false,
      showErrorAlert: false,
      uploadsuccess: false,
      uploaderror: false,
      uploadErrorMessage: '',
      uploadstarted: false,
      deleteStarted: false,
      isLoading: false,
      personFilterDialog: false,
      mediaFilterDialog: false,
      showAdditionalUpload: false,
      showVideoUpload: false,
      videoDialog: false,

      aktuellesBild: null,
      AssemblyID: 0,
      uploadedimage: null,
      additionalImageFile: null,
      additionalImageName: '',
      videoFile: null,
      videoName: '',
      videos: [],
      videosLoading: false,
      videoUploadStarted: false,
      videoDeleteStarted: 0,
      videoThumbRefreshStarted: 0,
      videoThumbCacheVersion: Date.now(),
      videoError: '',
      videoStreamError: '',
      selectedVideo: null,
      selectedVideoStreamUrl: '',
      manualGeoLoading: false,
      manualUploadCoordinates: null,
      uploadGeoInfo: '',
      uploadGeoInfoType: 'info',

      page: 1,
      page_numberofitems: 20,
      page_numberofpages: 50,
      page_offset: 0,

      ausgewaehltePersonenTags: [],
      nurBilderMitPersonenTags: false,
      mediaTypeFilter: 'all',

      defaultImageSizes: '(max-width: 600px) 50vw, (max-width: 1200px) 25vw, 220px'
    }
  },

  watch: {
    async additionalImageFile() {
      await this.updateAdditionalImageGeoInfo()
    },

    videoDialog(value) {
      if (!value) {
        this.closeVideo()
      }
    }
  },

  computed: {
    ...mapGetters({
      bilderRoh: 'stateBilder',
      settings: 'stateSettings'
    }),

    bilder() {
      return (this.bilderRoh || []).map(this.normalizeBild)
    },

    verfuegbarePersonenTags() {
      const tags = new Set()
      for (const bild of this.bilder) {
        for (const tag of bild.personTags) {
          tags.add(tag)
        }
      }
      return Array.from(tags).sort()
    },

    personenFilterSummary() {
      const parts = []

      if (this.nurBilderMitPersonenTags) {
        parts.push('nur mit Personen-Tags')
      }

      if (this.ausgewaehltePersonenTags.length) {
        parts.push(`${this.ausgewaehltePersonenTags.length} Tags aktiv`)
      }

      return parts.length ? parts.join(', ') : 'kein Personenfilter aktiv'
    },

    mediaFilterSummary() {
      if (this.mediaTypeFilter === 'images') return 'nur Bilder'
      if (this.mediaTypeFilter === 'videos') return 'nur Videos'
      return 'alle Medien'
    },

    gefilterteBilder() {
      let result = [...this.bilder]

      if (this.nurBilderMitPersonenTags) {
        result = result.filter(bild => bild.personTags.length > 0)
      }

      if (this.ausgewaehltePersonenTags.length > 0) {
        result = result.filter(bild =>
          this.ausgewaehltePersonenTags.every(tag =>
            bild.personTags.includes(tag)
          )
        )
      }

      return result
    },

    selectedAdditionalImageFile() {
      if (Array.isArray(this.additionalImageFile)) {
        return this.additionalImageFile[0] || null
      }

      return this.additionalImageFile
    },

    selectedVideoFile() {
      if (Array.isArray(this.videoFile)) {
        return this.videoFile[0] || null
      }

      return this.videoFile
    },

    videoItems() {
      return Array.isArray(this.videos) ? this.videos : []
    },

    assemblyNameById() {
      const result = new Map()
      for (const bild of this.bilder) {
        const assemblyId = this.getBildAssemblyId(bild)
        const assemblyName = String(bild?.assembly_Benennung || '').trim()
        if (assemblyId > 0 && assemblyName) {
          result.set(assemblyId, assemblyName)
        }
      }
      return result
    },

    albumMediaItems() {
      const images = this.gefilterteBilder.map(bild => ({
        type: 'image',
        key: `image-${bild.idBilder}`,
        item: bild,
        title: bild.assembly_Benennung || '-',
        idText: bild.idBilder,
        faceText: this.formatDateTime(bild.face_last_processed_at) || '-',
        dateText: this.formatDate(bild.bilder_UploadDate) || 'kein Datum',
        latitude: bild.bilder_geo_lati_Y,
        longitude: bild.bilder_geo_longi_X,
        hasCoordinates: this.hasBildCoordinates(bild),
        sortValue: this.getMediaSortValue(bild.bilder_UploadDate, bild.idBilder)
      }))

      const videos = this.videoItems.map(video => {
        const videoId = this.getVideoId(video)
        const assemblyId = Number(
          video?.assembly_id ??
          video?.assembly_idassembly ??
          video?.Assembly_idassembly ??
          video?.idassembly ??
          video?.idAssembly ??
          video?.assembly?.idassembly ??
          video?.assembly?.id ??
          0
        )
        const assemblyName = String(
          video?.assembly_Benennung ||
          video?.assembly_name ||
          video?.assembly_title ||
          video?.assembly?.assembly_Benennung ||
          video?.assembly?.name ||
          this.assemblyNameById.get(assemblyId) ||
          ''
        ).trim()

        return {
          type: 'video',
          key: `video-${videoId || video.video_benennung || video.title}`,
          item: video,
          title: assemblyName || video.video_benennung || video.title || 'Video',
          idText: videoId || '-',
          faceText: this.formatDateTime(video.face_last_processed_at) || '-',
          dateText: this.formatDate(video.bilder_UploadDate || video.video_upload_date || video.upload_date || video.created_at) || 'kein Datum',
          durationText: this.formatVideoDurationLabel(video),
          sizeText: this.formatVideoSize(video),
          latitude: video.bilder_geo_lati_Y,
          longitude: video.bilder_geo_longi_X,
          hasCoordinates: this.hasVideoCoordinates(video),
          sortValue: this.getMediaSortValue(video.video_upload_date || video.created_at || video.upload_date, videoId)
        }
      })

      const media = []
      if (this.mediaTypeFilter !== 'videos') {
        media.push(...images)
      }
      if (this.mediaTypeFilter !== 'images') {
        media.push(...videos)
      }

      return media.sort((left, right) => right.sortValue - left.sortValue)
    },

    selectedVideoAssemblyName() {
      const video = this.selectedVideo
      if (!video) return '-'

      const assemblyId = Number(
        video?.assembly_id ??
        video?.assembly_idassembly ??
        video?.Assembly_idassembly ??
        video?.idassembly ??
        video?.idAssembly ??
        video?.assembly?.idassembly ??
        video?.assembly?.id ??
        0
      )
      const assemblyName = String(
        video?.assembly_Benennung ||
        video?.assembly_name ||
        video?.assembly_title ||
        video?.assembly?.assembly_Benennung ||
        video?.assembly?.name ||
        this.assemblyNameById.get(assemblyId) ||
        ''
      ).trim()

      return assemblyName || '-'
    },

    selectedVideoName() {
      return this.selectedVideo?.video_benennung || this.selectedVideo?.title || ''
    },

    selectedVideoUploadDate() {
      return this.selectedVideo?.bilder_UploadDate ||
        this.selectedVideo?.video_upload_date ||
        this.selectedVideo?.upload_date ||
        this.selectedVideo?.created_at ||
        ''
    },

    selectedVideoLatitude() {
      const value = this.selectedVideo?.bilder_geo_lati_Y
      return value === null || value === undefined ? '' : value
    },

    selectedVideoLongitude() {
      const value = this.selectedVideo?.bilder_geo_longi_X
      return value === null || value === undefined ? '' : value
    },

    currentLatitude() {
      return this.toCoordinateNumber(this.aktuellesBild?.bilder_geo_lati_Y)
    },

    currentLongitude() {
      return this.toCoordinateNumber(this.aktuellesBild?.bilder_geo_longi_X)
    },

    hasCurrentCoordinates() {
      return this.hasCoordinates(this.currentLatitude, this.currentLongitude)
    },

    currentMapUrl() {
      if (!this.hasCurrentCoordinates) return ''

      const lat = this.currentLatitude
      const lon = this.currentLongitude
      const delta = 0.01
      const bbox = [
        lon - delta,
        lat - delta,
        lon + delta,
        lat + delta
      ].join(',')

      return `https://www.openstreetmap.org/export/embed.html?bbox=${bbox}&layer=mapnik&marker=${lat},${lon}`
    },

    currentOsmUrl() {
      if (!this.hasCurrentCoordinates) return ''

      return `https://www.openstreetmap.org/?mlat=${this.currentLatitude}&mlon=${this.currentLongitude}#map=16/${this.currentLatitude}/${this.currentLongitude}`
    }
  },

  methods: {
    ...mapActions(['deleteBild']),

    normalizeBild(bild) {
      return {
        ...bild,
        personTags: this.extractPersonTags(bild?.tag)
      }
    },

    extractPersonTags(rawTag) {
      if (!rawTag) return []

      if (Array.isArray(rawTag)) {
        return rawTag.filter(tag => typeof tag === 'string' && tag.startsWith('person_'))
      }

      if (typeof rawTag === 'string') {
        return rawTag.match(/person_[^"',\]]+/g) || []
      }

      return []
    },

    formatDateTime(value) {
      if (!value || typeof value !== 'string') return ''
      return value.substring(0, 19).replace('T', ' ')
    },

    formatDate(value) {
      if (!value || typeof value !== 'string') return ''
      return value.substring(0, 10)
    },

    toCoordinateNumber(value) {
      if (value === null || value === undefined || value === '') return null
      const numberValue = Number(String(value).replace(',', '.'))
      return Number.isFinite(numberValue) ? numberValue : null
    },

    hasBildCoordinates(bild) {
      return this.hasCoordinates(
        this.toCoordinateNumber(bild?.bilder_geo_lati_Y),
        this.toCoordinateNumber(bild?.bilder_geo_longi_X)
      )
    },

    hasVideoCoordinates(video) {
      return this.hasCoordinates(
        this.toCoordinateNumber(video?.bilder_geo_lati_Y),
        this.toCoordinateNumber(video?.bilder_geo_longi_X)
      )
    },

    formatCoordinate(value) {
      const numberValue = this.toCoordinateNumber(value)
      return Number.isFinite(numberValue) ? numberValue.toFixed(6) : '-'
    },

    getCoordinatesFromObject(item) {
      if (!item || typeof item !== 'object') return null

      const latitude = this.toCoordinateNumber(
        item.bilder_geo_lati_Y ??
        item.assembly_geo_lati_Y ??
        item.geo_lati_Y ??
        item.latitude ??
        item.lat ??
        item.assembly?.bilder_geo_lati_Y ??
        item.assembly?.geo_lati_Y ??
        item.assembly?.latitude ??
        item.assembly?.lat
      )
      const longitude = this.toCoordinateNumber(
        item.bilder_geo_longi_X ??
        item.assembly_geo_longi_X ??
        item.geo_longi_X ??
        item.longitude ??
        item.lon ??
        item.lng ??
        item.assembly?.bilder_geo_longi_X ??
        item.assembly?.geo_longi_X ??
        item.assembly?.longitude ??
        item.assembly?.lon ??
        item.assembly?.lng
      )

      return this.hasCoordinates(latitude, longitude)
        ? { latitude, longitude }
        : null
    },

    async getSelectedAssemblyCoordinates() {
      const directCoordinates = this.getCoordinatesFromObject(this.aktuellesBild)
      if (directCoordinates) return directCoordinates

      const selectedId = Number(this.AssemblyID || 0)
      if (!selectedId) return null

      try {
        const { data } = await axios.get(`/assemblies/${selectedId}/media`)
        const media = Array.isArray(data) ? data : []
        for (const item of media) {
          const coordinates = this.getCoordinatesFromObject(item)
          if (coordinates) return coordinates
        }
      } catch (error) {
        console.error(error)
      }

      return null
    },

    getMediaSortValue(dateValue, fallbackId = 0) {
      const time = dateValue ? new Date(dateValue).getTime() : NaN
      if (Number.isFinite(time)) return time
      const id = Number(fallbackId)
      return Number.isFinite(id) ? id : 0
    },

    encodeUriSafe(url) {
      return url ? encodeURI(url) : ''
    },

    alleTagsAuswaehlen() {
      this.ausgewaehltePersonenTags = [...this.verfuegbarePersonenTags]
    },

    alleTagsAbwaehlen() {
      this.ausgewaehltePersonenTags = []
    },

    async ladeBilder() {
      this.isLoading = true
      try {
        const bilder = await this.$store.dispatch('getBilder', {
          offset: this.page_offset,
          anzahl_Bilder: this.page_numberofitems
        })
        await this.ladeVideosFuerBilder(Array.isArray(bilder) ? bilder : this.gefilterteBilder)
      } finally {
        this.isLoading = false
      }
    },

    async springeZuSeite() {
      this.page_offset = (this.page_numberofitems * this.page) - this.page_numberofitems
      await this.ladeBilder()
    },

    showImage(bild) {
      this.aktuellesBild = { ...bild }
      this.AssemblyID = this.getBildAssemblyId(bild)
      this.resetAdditionalUpload()
      this.dialog = true
    },

    openAlbumMedia(media) {
      if (media?.type === 'video') {
        this.showVideo(media.item)
        return
      }

      this.showImage(media.item)
    },

    async rotate90Bild() {
      if (!this.aktuellesBild?.idBilder) return

      const BilderForm = new FormData()
      BilderForm.append('Bild_id', this.aktuellesBild.idBilder)
      BilderForm.append('RotationWinkel', -90)

      try {
        const response = await this.$store.dispatch('createBildRotate', BilderForm)

        if (response?.Bild_URL) {
          this.aktuellesBild.Bild_URL = response.Bild_URL
        }

        await this.ladeBilder()
      } catch (error) {
        console.error(error)
        this.uploaderror = true
        this.uploadErrorMessage = formatImageUploadError(error, 'Bild drehen / Ansicht aktualisieren')
      }
    },

    async saveMasterdata() {
      if (!this.aktuellesBild?.idBilder) return

      const formData = new FormData()
      formData.append('Bild_id', this.aktuellesBild.idBilder)
      formData.append('Bilder_Benennung', this.aktuellesBild.Bilder_Benennung || '')
      formData.append('Assembly_Benennung', this.aktuellesBild.assembly_Benennung || '')
      formData.append('bilder_geo_lati_Y', this.aktuellesBild.bilder_geo_lati_Y || '')
      formData.append('bilder_geo_longi_X', this.aktuellesBild.bilder_geo_longi_X || '')

      this.uploaderror = false
      try {
        await this.$store.dispatch('updateBild', formData)
        await this.ladeBilder()
      } catch (error) {
        this.uploaderror = true
        this.uploadErrorMessage = formatImageUploadError(error, 'Bild bearbeiten / Ansicht aktualisieren')
      }
    },

    openDeleteDialog() {
      if (!this.aktuellesBild?.idBilder) return

      this.deleteDialog = true
    },

    async confirmDeleteBild() {
      if (!this.aktuellesBild?.idBilder) return

      this.deleteStarted = true

      try {
        await this.deleteBild(this.aktuellesBild.idBilder)
        this.deleteDialog = false
        this.dialog = false
        await this.ladeBilder()
        await this.$nextTick()
        this.aktuellesBild = null
      } catch (error) {
        console.error(error)
        this.uploaderror = true
        this.uploadErrorMessage = formatImageUploadError(error, 'Bild löschen / Ansicht aktualisieren')
      } finally {
        this.deleteStarted = false
      }
    },

    openAdditionalUpload() {
      this.additionalImageFile = null
      this.additionalImageName = this.aktuellesBild?.Bilder_Benennung || ''
      this.uploadsuccess = false
      this.uploaderror = false
      this.manualUploadCoordinates = null
      this.manualGeoLoading = false
      this.uploadGeoInfo = 'Bitte Bild auswaehlen. Wenn das Frontend keine EXIF-GPS-Koordinaten findet, werden keine Koordinaten gesendet, damit die API EXIF serverseitig auslesen kann.'
      this.uploadGeoInfoType = 'info'
      this.showAdditionalUpload = true
    },

    resetAdditionalUpload() {
      this.showAdditionalUpload = false
      this.additionalImageFile = null
      this.additionalImageName = ''
      this.uploadsuccess = false
      this.uploaderror = false
      this.manualUploadCoordinates = null
      this.manualGeoLoading = false
      this.uploadGeoInfo = ''
      this.uploadGeoInfoType = 'info'
    },

    getBildAssemblyId(bild) {
      return Number(
        bild?.assembly_idassembly ??
        bild?.Assembly_idassembly ??
        bild?.assembly_id ??
        bild?.Assembly_id ??
        bild?.idassembly ??
        bild?.idAssembly ??
        bild?.assembly?.idassembly ??
        bild?.assembly?.id ??
        0
      )
    },

    getVideoAssemblyId(video) {
      return Number(
        video?.assembly_id ??
        video?.assembly_idassembly ??
        video?.Assembly_idassembly ??
        video?.idassembly ??
        video?.idAssembly ??
        video?.assembly?.idassembly ??
        video?.assembly?.id ??
        0
      )
    },

    getVideoAssemblyName(video) {
      const directName = String(
        video?.assembly_Benennung ||
        video?.assembly_name ||
        video?.assembly_title ||
        video?.assembly?.assembly_Benennung ||
        video?.assembly?.name ||
        ''
      ).trim()
      if (directName) return directName

      return this.assemblyNameById.get(this.getVideoAssemblyId(video)) || ''
    },

    getVideoId(video) {
      return Number(video?.idvideos ?? video?.id ?? 0)
    },

    getBrowserMediaUrl(url) {
      const rawUrl = String(url || '').trim()
      if (!rawUrl) return ''
      if (/^(blob:|data:|https?:\/\/)/i.test(rawUrl)) return rawUrl

      const apiBase = String(getApiBaseUrl() || '').replace(/\/+$/, '')
      const mediaPath = rawUrl.startsWith('/') ? rawUrl : `/${rawUrl}`
      if (!apiBase || apiBase === '/') return mediaPath

      if (apiBase.endsWith('/api') && mediaPath.startsWith('/api/')) {
        return `${apiBase.slice(0, -4)}${mediaPath}`
      }

      return `${apiBase}${mediaPath}`
    },

    getVideoStreamUrl(video) {
      const id = this.getVideoId(video)
      return video?.stream_url || video?.url || video?.video_url || (id ? `/videos/${id}/stream` : '')
    },

    getVideoThumbUrl(video) {
      const id = this.getVideoId(video)
      return video?.thumb_url || video?.video_thumb_url || (id ? `/videos/${id}/thumb` : '')
    },

    withUrlParams(url, params = {}) {
      const rawUrl = String(url || '').trim()
      if (!rawUrl) return ''

      const [baseUrl, hash = ''] = rawUrl.split('#')
      const separator = baseUrl.includes('?') ? '&' : '?'
      const query = Object.entries(params)
        .filter(([, value]) => value !== undefined && value !== null && value !== '')
        .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`)
        .join('&')

      if (!query) return rawUrl
      return `${baseUrl}${separator}${query}${hash ? `#${hash}` : ''}`
    },

    getVideoThumbBrowserUrl(video, options = {}) {
      const params = {}
      if (options.regenerate) params.regenerate = true
      params.v = options.version || video?.thumbVersion || this.videoThumbCacheVersion
      const url = this.withUrlParams(this.getVideoThumbUrl(video), params)
      return this.getBrowserMediaUrl(url)
    },

    revokeVideoObjectUrls() {
      this.selectedVideoStreamUrl = ''
    },

    extractVideoMediaItems(data) {
      if (Array.isArray(data)) return data
      if (Array.isArray(data?.videos)) return data.videos
      if (Array.isArray(data?.media)) return data.media
      if (Array.isArray(data?.items)) return data.items
      if (data && typeof data === 'object') return [data]
      return []
    },

    normalizeVideoItem(item) {
      const id = Number(item?.idvideos ?? item?.id ?? item?.video_id ?? 0)
      const thumbUrl = item?.thumb_url || item?.video_thumb_url || (id ? `/videos/${id}/thumb` : '')
      const assemblyId = Number(
        item?.assembly_id ??
        item?.assembly_idassembly ??
        item?.Assembly_idassembly ??
        item?.idassembly ??
        item?.idAssembly ??
        item?.assembly?.idassembly ??
        item?.assembly?.id ??
        0
      )
      return {
        ...item,
        idvideos: id || item?.idvideos,
        assembly_id: assemblyId || null,
        assembly_idassembly: assemblyId || item?.assembly_idassembly || null,
        idassembly: assemblyId || item?.idassembly || null,
        stream_url: item?.stream_url || item?.url || item?.video_url || (id ? `/videos/${id}/stream` : ''),
        thumb_url: thumbUrl,
        video_benennung: item?.video_benennung || item?.title || item?.filename || item?.original_filename || '',
        assembly_Benennung: item?.assembly_Benennung || item?.assembly_name || item?.assembly_title || item?.assembly?.assembly_Benennung || item?.assembly?.name || '',
        bilder_UploadDate: item?.bilder_UploadDate || item?.video_upload_date || item?.upload_date || item?.created_at || '',
        bilder_geo_lati_Y: item?.bilder_geo_lati_Y ?? item?.video_geo_lati_Y ?? item?.geo_lati_Y ?? item?.latitude ?? item?.lat ?? null,
        bilder_geo_longi_X: item?.bilder_geo_longi_X ?? item?.video_geo_longi_X ?? item?.geo_longi_X ?? item?.longitude ?? item?.lon ?? null,
        face_last_processed_at: item?.face_last_processed_at || '',
        thumbVersion: item?.thumbVersion || item?.video_updated_at || item?.video_created_at || item?.created_at || '',
        thumbLoadFailed: false
      }
    },

    isVideoMediaItem(item) {
      return String(item?.type || '').toLowerCase() === 'video'
    },

    async ladeVideosFuerSichtbareAssemblies() {
      await this.ladeVideosFuerBilder(this.gefilterteBilder)
    },

    async ladeVideosFuerBilder(bilder) {
      const assemblyIds = Array.from(new Set(
        (Array.isArray(bilder) ? bilder : [])
          .map(this.getBildAssemblyId)
          .filter(id => id > 0)
      ))

      this.videos = []
      if (!assemblyIds.length) return

      this.videosLoading = true
      this.videoError = ''

      try {
        const responses = await Promise.all(
          assemblyIds.map(assemblyId =>
            axios.get(`/assemblies/${assemblyId}/media`).catch(error => ({ error, data: [] }))
          )
        )
        this.videos = responses
          .flatMap(response => this.extractVideoMediaItems(response.data))
          .filter(this.isVideoMediaItem)
          .map(this.normalizeVideoItem)
      } catch (error) {
        console.error(error)
        this.videos = []
        this.videoError = error?.response?.data?.detail || error?.message || 'Videos konnten nicht geladen werden.'
      } finally {
        this.videosLoading = false
      }
    },

    async ladeVideosFuerAssembly(assemblyId) {
      this.videos = []
      if (!assemblyId) {
        return
      }

      this.videosLoading = true
      this.videoError = ''

      try {
        const { data } = await axios.get(`/assemblies/${assemblyId}/media`)
        this.videos = this.extractVideoMediaItems(data)
          .filter(this.isVideoMediaItem)
          .map(this.normalizeVideoItem)
      } catch (error) {
        console.error(error)
        this.videos = []
        this.videoError = error?.response?.data?.detail || error?.message || 'Videos konnten nicht geladen werden.'
      } finally {
        this.videosLoading = false
      }
    },

    handleVideoThumbnailError(video) {
      if (video) video.thumbLoadFailed = true
    },

    async refreshVideoThumbnail(video) {
      const videoId = this.getVideoId(video)
      if (!videoId) return

      this.videoThumbRefreshStarted = videoId
      this.videoError = ''

      try {
        const version = Date.now()
        video.thumbVersion = version
        this.videoThumbCacheVersion = version
        video.thumbLoadFailed = false
        await this.ladeVideosFuerSichtbareAssemblies()
      } catch (error) {
        console.error(error)
        this.videoError = error?.response?.data?.detail || error?.message || 'Thumbnail konnte nicht neu erzeugt werden.'
      } finally {
        this.videoThumbRefreshStarted = 0
      }
    },

    openVideoUpload() {
      this.videoFile = null
      this.videoName = this.aktuellesBild?.Bilder_Benennung || ''
      this.videoError = ''
      this.showVideoUpload = true
    },

    resetVideoUpload() {
      this.showVideoUpload = false
      this.videoFile = null
      this.videoName = ''
      this.videoUploadStarted = false
      this.videoError = ''
    },

    async uploadVideo() {
      const uploadFile = this.selectedVideoFile
      if (!uploadFile || !this.AssemblyID) return

      this.videoUploadStarted = true
      this.videoError = ''

      try {
        const formData = new FormData()
        formData.append('file', uploadFile)
        formData.append('assembly_id', this.AssemblyID)
        formData.append('video_benennung', this.videoName || uploadFile.name || '')

        const { data } = await axios.post('/videos/upload', formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        })
        const uploadedVideo = this.normalizeVideoItem(data)
        this.showVideoUpload = false
        this.videoFile = null
        this.videoName = ''
        await this.ladeVideosFuerSichtbareAssemblies()
        if (this.getVideoId(uploadedVideo) && !this.videoItems.some(video => this.getVideoId(video) === this.getVideoId(uploadedVideo))) {
          this.videos = [uploadedVideo, ...this.videoItems]
        }
      } catch (error) {
        console.error(error)
        this.videoError = error?.response?.data?.detail || error?.message || 'Video konnte nicht hochgeladen werden.'
      } finally {
        this.videoUploadStarted = false
      }
    },

    async showVideo(video) {
      const streamUrl = this.getBrowserMediaUrl(this.getVideoStreamUrl(video))
      if (!streamUrl) return

      this.selectedVideo = video
      this.AssemblyID = this.getVideoAssemblyId(video)
      this.aktuellesBild = {
        assembly_Benennung: this.getVideoAssemblyName(video),
        Bilder_Benennung: video?.video_benennung || video?.title || ''
      }
      this.selectedVideoStreamUrl = streamUrl
      this.videoDialog = true
      this.videoError = ''
      this.videoStreamError = ''
    },

    handleVideoStreamError() {
      this.videoStreamError = 'Video-Stream konnte nicht geladen werden.'
    },

    closeVideo() {
      this.videoDialog = false
      this.selectedVideo = null
      this.selectedVideoStreamUrl = ''
      this.videoStreamError = ''
    },

    async deleteVideo(video) {
      const videoId = this.getVideoId(video)
      if (!videoId) return

      this.videoDeleteStarted = videoId
      this.videoError = ''

      try {
        await axios.delete(`/videos/${videoId}`)
        this.closeVideo()
        await this.ladeBilder()
      } catch (error) {
        console.error(error)
        this.videoError = error?.response?.data?.detail || error?.message || 'Video konnte nicht geloescht werden.'
      } finally {
        this.videoDeleteStarted = 0
      }
    },

    formatVideoDuration(value) {
      const seconds = Number(value)
      if (!Number.isFinite(seconds) || seconds <= 0) return 'Dauer unbekannt'
      const rounded = Math.round(seconds)
      const minutes = Math.floor(rounded / 60)
      const rest = String(rounded % 60).padStart(2, '0')
      return `${minutes}:${rest} min`
    },

    formatVideoDurationLabel(video) {
      const label = String(video?.duration_label || video?.video_duration_label || '').trim()
      if (label) return `${label} min`

      return this.formatVideoDuration(
        video?.duration_seconds ??
        video?.video_duration_seconds
      )
    },

    formatVideoSize(video) {
      const mb = Number(video?.size_mb ?? video?.video_size_mb)
      if (Number.isFinite(mb) && mb > 0) {
        return `${mb.toLocaleString('de-DE', {
          minimumFractionDigits: 0,
          maximumFractionDigits: 2
        })} MB`
      }

      const bytes = Number(video?.size_bytes ?? video?.video_size_bytes)
      if (!Number.isFinite(bytes) || bytes <= 0) return 'Groesse unbekannt'

      return `${(bytes / 1024 / 1024).toLocaleString('de-DE', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      })} MB`
    },

    async useCurrentPositionForUpload() {
      this.manualGeoLoading = true

      try {
        const coordinates = await this.getCurrentPositionOnce()

        if (!this.hasCoordinates(coordinates.latitude, coordinates.longitude)) {
          this.uploadGeoInfo = 'Browser-Geolocation hat keine gueltigen Koordinaten geliefert.'
          this.uploadGeoInfoType = 'warning'
          return
        }

        this.manualUploadCoordinates = coordinates
        this.uploadGeoInfo = `Aktuelle Position wird beim Upload verwendet: ${this.formatCoordinate(coordinates.latitude)}, ${this.formatCoordinate(coordinates.longitude)}.`
        this.uploadGeoInfoType = 'success'
      } catch (error) {
        console.error(error)
        this.uploadGeoInfo = 'Aktuelle Position konnte nicht ermittelt werden. Browser-Freigabe pruefen.'
        this.uploadGeoInfoType = 'warning'
      } finally {
        this.manualGeoLoading = false
      }
    },

    isMobileUploadDevice() {
      const userAgent = String(navigator.userAgent || '').toLowerCase()
      const hasTouch = navigator.maxTouchPoints && navigator.maxTouchPoints > 1

      return (
        /android|iphone|ipad|ipod|mobile/.test(userAgent) ||
        (hasTouch && Math.min(window.innerWidth, window.innerHeight) <= 900)
      )
    },

    async updateAdditionalImageGeoInfo() {
      const uploadFile = this.selectedAdditionalImageFile

      if (!uploadFile) {
        if (this.showAdditionalUpload) {
          this.uploadGeoInfo = 'Bitte Bild auswaehlen. Wenn das Frontend keine EXIF-GPS-Koordinaten findet, werden keine Koordinaten gesendet, damit die API EXIF serverseitig auslesen kann.'
          this.uploadGeoInfoType = 'info'
        }
        return
      }

      const exifCoordinates = await this.getExifCoordinates(uploadFile)

      if (exifCoordinates) {
        this.uploadGeoInfo = `EXIF-GPS gefunden: ${this.formatCoordinate(exifCoordinates.latitude)}, ${this.formatCoordinate(exifCoordinates.longitude)}. Diese Koordinaten werden beim Upload verwendet.`
        this.uploadGeoInfoType = 'success'
        return
      }

      if (this.manualUploadCoordinates) {
        this.uploadGeoInfo = `Keine EXIF-GPS-Koordinaten gefunden. Aktuelle Position per Button gewaehlt: ${this.formatCoordinate(this.manualUploadCoordinates.latitude)}, ${this.formatCoordinate(this.manualUploadCoordinates.longitude)}.`
        this.uploadGeoInfoType = 'success'
        return
      }

      const assemblyCoordinates = await this.getSelectedAssemblyCoordinates()
      if (assemblyCoordinates) {
        this.uploadGeoInfo = `Keine EXIF-GPS-Koordinaten gefunden. Beim Upload werden die GPS-Koordinaten des ausgewaehlten Assembly verwendet: ${this.formatCoordinate(assemblyCoordinates.latitude)}, ${this.formatCoordinate(assemblyCoordinates.longitude)}.`
        this.uploadGeoInfoType = 'info'
        return
      }

      this.uploadGeoInfo = 'Keine EXIF-GPS-Koordinaten gefunden. Aktuelle Position kann per Button verwendet werden; ansonsten werden keine Geo-Koordinaten gesendet.'
      this.uploadGeoInfoType = 'info'
    },

    async resolveUploadCoordinates(uploadFile) {
      const exifCoordinates = await this.getExifCoordinates(uploadFile)

      if (exifCoordinates) {
        return {
          ...exifCoordinates,
          source: 'exif',
          message: `EXIF-GPS gefunden und verwendet: ${this.formatCoordinate(exifCoordinates.latitude)}, ${this.formatCoordinate(exifCoordinates.longitude)}.`
        }
      }

      if (this.manualUploadCoordinates) {
        return {
          ...this.manualUploadCoordinates,
          source: 'manual-browser',
          message: `Keine EXIF-GPS-Koordinaten gefunden. Manuell gewaehlte aktuelle Position verwendet: ${this.formatCoordinate(this.manualUploadCoordinates.latitude)}, ${this.formatCoordinate(this.manualUploadCoordinates.longitude)}.`
        }
      }

      const assemblyCoordinates = await this.getSelectedAssemblyCoordinates()
      if (assemblyCoordinates) {
        return {
          ...assemblyCoordinates,
          source: 'assembly',
          message: `Keine EXIF-GPS-Koordinaten gefunden. GPS-Koordinaten des ausgewaehlten Assembly verwendet: ${this.formatCoordinate(assemblyCoordinates.latitude)}, ${this.formatCoordinate(assemblyCoordinates.longitude)}.`
        }
      }

      return {
        latitude: null,
        longitude: null,
        source: 'none',
        message: 'Keine EXIF-GPS-Koordinaten gefunden, keine manuelle Position gewaehlt und keine Assembly-GPS-Koordinaten vorhanden. Es wurden keine Geo-Koordinaten gesendet.'
      }
    },

    async uploadAdditionalImage() {
      const uploadFile = this.selectedAdditionalImageFile
      if (!uploadFile || !this.AssemblyID) return

      this.uploadstarted = true
      this.uploadsuccess = false
      this.uploaderror = false
      let operation = 'Bild hochladen'

      try {
        const { latitude, longitude, source, message } = await this.resolveUploadCoordinates(uploadFile)
        const formData = new FormData()
        formData.append('file', uploadFile)
        formData.append('assembly_id', this.AssemblyID)
        if (this.hasCoordinates(latitude, longitude)) {
          formData.append('bilder_geo_longi_X', longitude)
          formData.append('bilder_geo_lati_Y', latitude)
        }
        formData.append(
          'Bilder_Benennung',
          this.additionalImageName || uploadFile.name || ''
        )

        await this.$store.dispatch('createBildmitfiles', formData)
        this.uploadsuccess = true
        this.uploadGeoInfo = message
        this.uploadGeoInfoType = source === 'none' || source === 'server-exif' ? 'info' : 'success'
        this.showAdditionalUpload = false
        this.additionalImageFile = null
        this.additionalImageName = ''
        this.manualUploadCoordinates = null
        operation = 'Bild gespeichert, Bildliste aktualisieren'
        await this.ladeBilder()
      } catch (error) {
        console.error(error)
        this.uploaderror = true
        this.uploadErrorMessage = formatImageUploadError(error, operation)
      } finally {
        this.uploadstarted = false
      }
    }
  },

  async created() {
    await this.ladeBilder()
  },

  beforeUnmount() {
    this.revokeVideoObjectUrls()
  }
}
</script>

<style scoped>
.image-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 12px;
}

.image-card {
  cursor: pointer;
  border-radius: 10px;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.03);
}

.image-thumb-wrapper {
  position: relative;
  width: 100%;
  height: 220px;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.06);
}

.image-thumb {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
  object-position: center;
}

.image-meta {
  padding: 8px;
  font-size: 0.92rem;
  line-height: 1.35;
  word-break: break-word;
}

.meta-title {
  font-weight: 600;
  margin-bottom: 4px;
}

.meta-line {
  margin-bottom: 2px;
}

.filter-toolbar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}

.filter-summary {
  color: rgba(255, 255, 255, 0.7);
  font-size: 0.9rem;
}

.filter-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.media-filter-toggle {
  width: 100%;
}

.geo-fields {
  margin: 0;
}

.map-actionbar {
  display: flex;
  gap: 8px;
  padding: 0 16px 12px;
}

.map-section {
  padding: 0 16px 16px;
}

.map-title {
  font-weight: 600;
  margin-bottom: 8px;
}

.map-frame {
  width: 100%;
  height: 280px;
  display: block;
  border: 0;
  border-radius: 8px;
}

.upload-target {
  margin-bottom: 12px;
  word-break: break-word;
}

.manual-upload-coordinates {
  margin-bottom: 12px;
  font-size: 0.92rem;
  font-weight: 600;
}

.video-thumb-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.video-play-overlay {
  position: absolute;
  left: 50%;
  top: 50%;
  width: 56px;
  height: 56px;
  transform: translate(-50%, -50%);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  color: #fff;
  background: rgba(0, 0, 0, 0.68);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.35);
  pointer-events: none;
}

.video-player {
  width: 100%;
  max-height: 72vh;
  display: block;
  background: #000;
}

</style>
